<router-outlet></router-outlet>

<!--
    Mobile install gate. Renders a full-screen install prompt over
    the entire app (including the sign-in screen) whenever a user
    on a mobile browser hasn't installed the PWA yet. Hidden on
    desktop, hidden in standalone mode (already installed), and
    soft-dismissable per-session via a "Continue in browser
    anyway" link inside the gate. See the component for the full
    visibility matrix.
-->
<mobile-install-gate></mobile-install-gate>

@if (envName && showEnvOverlay) {
    <div class="env-overlay" [style.--env-color]="envColor" aria-hidden="true">
        <div class="env-overlay__watermark">{{ envName }}</div>
    </div>
}

<!-- TEMP: the small "show" pill is hidden alongside the giant watermark
     so the UI reads cleanly during the current design review. Restore
     the @if block below to bring back the bottom-right toggle pill.
     Ctrl+Shift+E continues to toggle the overlay regardless. -->
<!--
@if (envName && !showEnvOverlay) {
    <button class="env-overlay__show-btn"
            [style.--env-color]="envColor"
            (click)="toggleEnvOverlay()"
            title="Show environment overlay (Ctrl+Shift+E)">
        {{ envName }}
    </button>
}
-->

